


















































































import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { useCategory } from '@/bundles/Category/composables/useCategory';

export default defineComponent({
  name: 'UpsertCategory',

  props: {
    value: Boolean,
    isEdit: Boolean,
    selectedCategory: {
      type: Object,
      default: () => ({})
    }
  },

  emits: ['updateCategory', 'deleteCategory'],

  setup(props, { emit }) {
    const showModal = computed({
      get: () => props.value,
      set: (value: boolean) => {
        emit('input', value);
      }
    });

    let category = ref({
      name: null,
      description: null,
      exercise_description: null,
      execution_time: null,
      success_threshold: null,
    });

    watch(
      () => showModal.value,
      (value: boolean) => {
        if (!value) {
          closeEventHandler();
          return;
        }

        const { id, ...tempCategory } = props.selectedCategory;

        category.value = { ...category.value, ...tempCategory };
      }
    );

    const categoryForm = ref<any>(null);

    function closeEventHandler() {
      categoryForm.value.reset();
      showModal.value = false;
    }

    const { create, edit, deleteCategory } = useCategory();
    const loading = ref(false);

    async function submitHandler() {
      try {
        if (!categoryForm.value.validate()) {
          return;
        }

        loading.value = true;

        if (props.isEdit) {
          const response = await edit({
            id: props.selectedCategory.id,
            payload: category.value
          });

          emit('updateCategory', response);
          showModal.value = false;
          return;
        }

        const response = await create(category.value);
        emit('addCategory', response);
        showModal.value = false;
      } catch (e) {
        console.error(e);
      } finally {
        loading.value = false;
      }
    }

    const isDeleting = ref(false);

    async function deleteCategoryHandler() {
      try {
        isDeleting.value = true;

        await deleteCategory(props.selectedCategory.id);
        emit('deleteCategory', props.selectedCategory.id);
        showModal.value = false;
      } catch (e) {
        console.error(e);
      } finally {
        isDeleting.value = false;
      }
    }

    return {
      showModal,
      categoryForm,
      category,
      loading,
      isDeleting,
      closeEventHandler,
      submitHandler,
      deleteCategoryHandler
    };
  }
});
